module.exports = __webpack_public_path__ + "img/fk.73b91eb5.svg";